module.exports = __webpack_public_path__ + "img/booking_completed.1ac83daf.svg";